import { render, staticRenderFns } from "./HistoricalReportTable.vue?vue&type=template&id=1ab2a034&scoped=true"
import script from "./HistoricalReportTable.vue?vue&type=script&lang=js"
export * from "./HistoricalReportTable.vue?vue&type=script&lang=js"
import style0 from "./HistoricalReportTable.vue?vue&type=style&index=0&id=1ab2a034&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab2a034",
  null
  
)

export default component.exports